import { useEffect, useState } from 'react';

export const useGetIsListHalfVisible = (
  element: Element | null | undefined
) => {
  const [isHalfVisible, setIsHalfVisible] = useState(false);

  useEffect(() => {
    function observerCallback(entries: IntersectionObserverEntry[]) {
      if (entries?.[0]) {
        setIsHalfVisible(
          entries[0].boundingClientRect.bottom -
            (entries[0].rootBounds?.bottom ?? 0) <
            entries[0].boundingClientRect.height
        );
      }
    }

    const observer = new IntersectionObserver(observerCallback, {
      threshold: [0.1, 0.25, 0.33, 0.5, 1.0],
    });

    if (element) {
      observer.observe(element);
    }

    return () => {
      observer.disconnect();
    };
  }, [element]);

  return isHalfVisible;
};
